import { Action } from "../../../actions/actions";
import { VppsActionTypes } from "../actions/actionTypes";

export function vppsUsers(
    state: { results: any[]; count: number } = {
        results: [],
        count: 0
    },
    action: Action
) {
    switch (action.type) {
        case VppsActionTypes.GET_VPPS_USERS_SUCCESS:
            return action.payload.users;

        default:
            return state;
    }
}

export function vppsUsersLoading(state: boolean = false, action: Action) {
    switch (action.type) {
        case VppsActionTypes.GET_VPPS_USERS:
            return true;

        case VppsActionTypes.GET_VPPS_USERS_FAIL:
        case VppsActionTypes.GET_VPPS_USERS_SUCCESS:
            return false;

        default:
            return state;
    }
}
